export const createCategoryService = async (data) => {
  try {
    if (!window.electron) throw new Error("Electron not available");
    const id = await window.electron.addProduct(data);
    return id;
  } catch (error) {
    console.error("Failed to add product:", error);
    throw error; // rethrow so react-query `onError` can catch it
  }
};

export const fetchAllCategories = async () => {
  try {
    const categories = await window.electron.getAllCategories();
    return categories;
  } catch (error) {
    console.error("Failed to add product:", error);
    throw error;
  }
};
